import React, { useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { mfaErr } from "../../lib/webauthn";

// Founder only (MFA_DESIGN §4): lost every device? A recovery code + a one-time email link resets your own factors.
// Nobody else can reset the Founder's two-step sign-in.
export default function FounderRecovery() {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { setSent((await api.post("/mfa/founder-recovery/start", { recovery_code: code.trim() })).data); setCode(""); }
    catch (x) { setErr(mfaErr(x)); }
    finally { setBusy(false); }
  };
  return (
    <section className="border border-erf-borderCream rounded p-4 space-y-2" data-testid="mfa-founder-recovery" aria-labelledby="mfa-founder-recovery-title">
      <h2 id="mfa-founder-recovery-title" className="font-display font-semibold">Lost all your devices?</h2>
      <p className="text-sm">As the Founder, you reset your own two-step sign-in with a recovery code and a link we email you. The link works once and expires in 15 minutes.</p>
      {sent && <p role="status" className="text-sm text-green-800" data-testid="mfa-founder-recovery-sent">We emailed a link to {sent.sent_to}. Open it within 15 minutes.</p>}
      {err && <p role="alert" className="text-sm text-red-700" data-testid="mfa-founder-recovery-error">{err}</p>}
      <form onSubmit={submit} className="flex flex-wrap gap-2 items-end">
        <label htmlFor="mfa-founder-recovery-code" className="text-xs">Recovery code
          <input id="mfa-founder-recovery-code" value={code} onChange={(e) => setCode(e.target.value)} autoComplete="off"
            className="block min-h-[44px] rounded border border-erf-borderCream px-3 text-sm" data-testid="mfa-founder-recovery-code" />
        </label>
        <Button type="submit" disabled={busy || code.trim().length < 6} variant="outline" className="min-h-[44px]"
          data-testid="mfa-founder-recovery-submit">Email me a reset link</Button>
      </form>
    </section>
  );
}
